import { Pipe, PipeTransform } from '@angular/core';

/** Hunt times are shown in IST, whatever the admin's own timezone. */
export function istDateTime(ms: number | null): string {
  if (!ms) return '—';
  return new Date(ms).toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit',
  });
}

/** 45s / 14 min / 1 h 5 min / 2 d 3 h */
export function humanDuration(msVal: number | null): string {
  if (msVal == null) return '—';
  const s = Math.max(0, Math.round(msVal / 1000));
  if (s < 60) return `${s}s`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  if (h < 48) return `${h} h${m % 60 ? ` ${m % 60} min` : ''}`;
  return `${Math.floor(h / 24)} d${h % 24 ? ` ${h % 24} h` : ''}`;
}

@Pipe({ name: 'ist' })
export class IstPipe implements PipeTransform {
  transform(ms: number | null): string { return istDateTime(ms); }
}

@Pipe({ name: 'duration' })
export class DurationPipe implements PipeTransform {
  transform(ms: number | null): string { return humanDuration(ms); }
}
